import React, { useState, useEffect } from 'react';
import { X, ChevronLeft, ChevronRight, Download } from 'lucide-react';

export default function GaleriaMasonry({ midias = [] }) {
  const [indexFoto, setIndexFoto] = useState(null);

  const fotoAtual = indexFoto !== null ? midias[indexFoto] : null;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (indexFoto === null) return;
      if (e.key === 'Escape') setIndexFoto(null);
      if (e.key === 'ArrowLeft') proximaFoto(-1);
      if (e.key === 'ArrowRight') proximaFoto(1);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [indexFoto, midias.length]);

  const proximaFoto = (direcao) => {
    setIndexFoto((prevIndex) => {
      if (prevIndex === null) return null;
      const novoIndex = prevIndex + direcao;
      if (novoIndex < 0) return midias.length - 1;
      if (novoIndex >= midias.length) return 0;
      return novoIndex;
    });
  };

  return (
    <div style={{ backgroundColor: '#020617', color: '#f8fafc', padding: '2rem 1rem', width: '100%' }}>
      {/* Cabeçalho */}
      <div style={{ maxWidth: '1200px', margin: '0 auto 2rem auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: '2.25rem', fontWeight: 'bold', color: '#FF6B00', marginBottom: '0.5rem' }}>
          Galeria de Fotos
        </h2>
        <p style={{ color: '#94a3b8', fontSize: '0.9rem' }}>
          Clique nas fotos para ver em tamanho amplo e navegar.
        </p>
      </div>

      {/* Grid Masonry em CSS Nativo */}
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          columnCount: 'auto',
          columnWidth: '250px',
          columnGap: '1rem'
        }}
      >
        {midias.map((item, index) => (
          <div
            key={item.id || index}
            onClick={() => setIndexFoto(index)}
            style={{
              breakInside: 'avoid',
              marginBottom: '1rem',
              position: 'relative',
              borderRadius: '0.75rem',
              overflow: 'hidden',
              backgroundColor: '#0f172a',
              border: '1px solid #1e293b',
              cursor: 'pointer',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(255, 107, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <img
              src={item.url}
              alt={item.titulo || `Foto ${index + 1}`}
              loading="lazy"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                borderRadius: '0.75rem'
              }}
              onError={(e) => {
                // Caso a imagem não exista no caminho indicado
                e.target.src = 'https://via.placeholder.com/400x300?text=Imagem+nao+encontrada';
              }}
            />
          </div>
        ))}
      </div>

      {/* Lightbox / Modal em Tela Cheia */}
      {fotoAtual && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(2, 6, 23, 0.92)',
            backdropFilter: 'blur(8px)'
          }}
        >
          {/* Botão Fechar */}
          <button
            onClick={() => setIndexFoto(null)}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              zIndex: 10000,
              padding: '0.5rem',
              borderRadius: '9999px',
              backgroundColor: 'rgba(15, 23, 42, 0.8)',
              color: '#fff',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <X size={28} />
          </button>

          {/* Seta Esquerda */}
          <button
            onClick={() => proximaFoto(-1)}
            style={{
              position: 'absolute',
              left: '1rem',
              zIndex: 10000,
              padding: '0.75rem',
              borderRadius: '9999px',
              backgroundColor: 'rgba(15, 23, 42, 0.8)',
              color: '#fff',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <ChevronLeft size={32} />
          </button>

          {/* Seta Direita */}
          <button
            onClick={() => proximaFoto(1)}
            style={{
              position: 'absolute',
              right: '1rem',
              zIndex: 10000,
              padding: '0.75rem',
              borderRadius: '9999px',
              backgroundColor: 'rgba(15, 23, 42, 0.8)',
              color: '#fff',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <ChevronRight size={32} />
          </button>

          {/* Conteúdo Central da Imagem Ampliada */}
          <div style={{ maxWidth: '90%', maxHeight: '85vh', textAlign: 'center' }}>
            <img
              src={fotoAtual.url}
              alt={fotoAtual.titulo}
              style={{
                maxHeight: '75vh',
                maxWidth: '100%',
                objectFit: 'contain',
                borderRadius: '0.75rem',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
              }}
            />

            {/* Rodapé com Download */}
            <div
              style={{
                marginTop: '1rem',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '1.5rem',
                backgroundColor: 'rgba(15, 23, 42, 0.9)',
                padding: '0.5rem 1.5rem',
                borderRadius: '1rem',
                border: '1px solid #1e293b'
              }}
            >
              <span style={{ fontSize: '0.9rem', color: '#fff' }}>
                {fotoAtual.titulo || `Registro #${indexFoto + 10}`}
              </span>
              <a
                href={fotoAtual.url}
                download
                target="_blank"
                rel="noreferrer"
                style={{
                  backgroundColor: '#FF6B00',
                  color: '#fff',
                  padding: '0.4rem 1rem',
                  borderRadius: '0.5rem',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                <Download size={16} /> Baixar
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}